import * as types from './action_types';
import DateMaster from '../utils/date_master';
import PointsLogger from '../../services/points_logger';

export const fetch = () => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.POINTS_LOG_RETRIEVING });
      const pointsLogData = await PointsLogger.fetch();
      const pointsLog = []
      for (let peopleNotification of pointsLogData) {
        pointsLog.push({
          description: peopleNotification.description,
          pointableEvent: peopleNotification.pointable_event,
          points: peopleNotification.points,
          createdAt: DateMaster.parseUTC(peopleNotification.created_at)
        });
      }
      dispatch({ type: types.POINTS_LOG_RETRIEVED, pointsLog });
    } catch(error) {
      dispatch({ type: types.POINTS_LOG_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/points_log/actions.js